module.exports = __webpack_public_path__ + "img/core-work.064dd357.jpg";